import { lazyWithRetry } from "utils/lazy-with-retry";

const CreateEvent = lazyWithRetry(() => import("./CreateEvent"));

export default CreateEvent;
